import React from 'react';
import InputGroup from '../input-group';
import InputField from '../input-field';
import UrlAction from '../style-tab-content-components/url-action';
import UrlTarget from '../style-tab-content-components/url-target';
import _ from 'lodash';

export default class LinkAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      urlValue: this.props.urlValue,
      passParams: this.props.passParams
    };

    this._onUserInput = this._onUserInput.bind(this);
    this._triggerURLChange = this._triggerURLChange.bind(this);
    this._toggleURLParamas = this._toggleURLParamas.bind(this);
    this._labelClicked = this._labelClicked.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      urlValue: nextProps.urlValue,
      passParams: nextProps.passParams});
  }

  _onUserInput(ev) {
    this.setState({
      urlValue: ev.target.value.trim()
    });
  }

  _triggerURLChange(ev) {
    this.props.changeHandler({
      type: 'urlChange',
      value: ev.target.value
    });
  }

  _labelClicked() {
    this.checkBoxEl.checked = !this.checkBoxEl.checked;
    const checkBoxEvent = { target: { checked: this.checkBoxEl.checked } };
    this._toggleURLParamas(checkBoxEvent);
  }

  _toggleURLParamas(ev) {
    this.props.changeHandler({
      type: 'passUrlParamsChange',
      value: ev.target.checked
    });
  }

  render() {
    return (
      <div>
        <InputGroup title='Action'>
          <UrlAction
            changeHandler={this.props.changeHandler}
            currentAction={this.props.urlAction}
          />
        </InputGroup>

        <InputGroup title='URL'>
          <InputField
            value={this.state.urlValue}
            valueChangeHandler={this._triggerURLChange}
            onKeyUp={this._onUserInput}
            hideLabel
          />
          <div className='form-elm checkbox-input append-params'>
            <input
              type='checkbox'
              className='checkbox
              form-elm-checkbox'
              id='append-params-checkbox'
              onChange={this._toggleURLParamas}
              checked={this.state.passParams}
              disabled={_.isEmpty(this.state.urlValue)}
              ref={(el) => { this.checkBoxEl = el; }}
            />
            <label
              className='right form-elm-checkbox-label'
              onClick={this._labelClicked}
            >
              Pass through URL Parameters
            </label>
          </div>
        </InputGroup>
        <InputGroup title='Target'>
          <UrlTarget
            changeHandler={this.props.changeHandler}
            currentTarget={this.props.target}
            disabled={_.isEmpty(this.state.urlValue)}
          />
        </InputGroup>
      </div>
    );
  }
}

LinkAction.propTypes = {
  passParams: React.PropTypes.bool,
  target: React.PropTypes.string,
  urlAction: React.PropTypes.string,
  changeHandler: React.PropTypes.func,
  urlValue: React.PropTypes.string
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/action-tab-content-components/link-action.jsx